import { Copy } from "lucide-react";
import { toast } from "sonner";
import { API } from "../lib/api";
import { Button } from "../components/ui/button";

const Block = ({ title, code, tid }) => (
  <div className="space-y-2">
    <h3 className="font-heading text-base font-semibold text-slate-200">{title}</h3>
    <div className="code-block relative">
      <Button size="sm" variant="ghost" className="absolute right-2 top-2 text-slate-400" onClick={() => { navigator.clipboard.writeText(code); toast.success("Copiado"); }} data-testid={tid}><Copy size={14} /></Button>
      <pre className="whitespace-pre-wrap pr-10">{code}</pre>
    </div>
  </div>
);

const examples = (base) => [
  ["Criar depósito (link de pagamento)", `curl -X POST ${base}/v1/deposits \\
  -H "Authorization: Bearer gw_sk_SUA_CHAVE" \\
  -H "Content-Type: application/json" \\
  -H "Idempotency-Key: pedido-123" \\
  -d '{"amount": 150.00, "description": "Depósito usuário 42", "reference": "user-42",
       "customer_email": "cliente@email.com",
       "success_url": "https://suaplataforma.com/ok", "cancel_url": "https://suaplataforma.com/cancelado"}'

# Resposta
{"id": "…", "type": "deposit", "amount": 150.0, "currency": "brl", "status": "pending",
 "checkout_url": "https://checkout.stripe.com/…", "fee": 0.0}`, "copy-docs-deposit"],
  ["Consultar depósito", `curl ${base}/v1/deposits/{id} -H "Authorization: Bearer gw_sk_SUA_CHAVE"
# status: pending | paid | expired | failed`, "copy-docs-get-deposit"],
  ["Solicitar saque / pagamento", `curl -X POST ${base}/v1/payouts \\
  -H "Authorization: Bearer gw_sk_SUA_CHAVE" \\
  -H "Content-Type: application/json" \\
  -d '{"amount": 80.00, "destination_type": "pix", "destination": "email@pix.com", "reference": "saque-9"}'
# status inicial: pending_approval (você aprova no painel com 2FA)`, "copy-docs-payout"],
  ["Consultar saldo", `curl ${base}/v1/balance -H "Authorization: Bearer gw_sk_SUA_CHAVE"`, "copy-docs-balance"],
  ["Validar webhook (Node.js)", `const crypto = require("crypto");
const ts = req.headers["x-gateway-timestamp"];
const sig = crypto.createHmac("sha256", WEBHOOK_SECRET).update(ts + "." + rawBody).digest("hex");
const ok = crypto.timingSafeEqual(Buffer.from(sig), Buffer.from(req.headers["x-gateway-signature"]));
// Rejeite também se Date.now()/1000 - ts > 300`, "copy-docs-webhook"],
];

export default function Docs() {
  return (
    <div className="max-w-4xl space-y-8 fade-up">
      <div>
        <p className="caption">API REST</p>
        <h1 className="font-heading text-4xl font-extrabold sm:text-5xl">Documentação</h1>
        <p className="mt-3 text-sm text-slate-400">URL base: <code className="text-emerald-300" data-testid="docs-base-url">{API}</code>. Autentique com <code>Authorization: Bearer</code>. Valores em reais (BRL). Limite: 60 req/min por chave. Use sempre do seu servidor, nunca no navegador.</p>
      </div>
      {examples(API).map(([t, c, tid]) => <Block key={tid} title={t} code={c} tid={tid} />)}
    </div>
  );
}
